import { createAction } from "redux-actions";

const CREATE_BLOG_POST = "CREATE_BLOG_POST";
const SEARCH_BLOG_POSTS = "SEARCH_BLOG_POSTS";
const SET_BLOG_POSTS = "SET_BLOG_POSTS";
const GET_BLOGS_POSTS_BY_CHANNEL = "GET_BLOGS_POSTS_BY_CHANNEL";
const SET_BLOGS_POSTS_BY_CHANNEL = "SET_BLOGS_POSTS_BY_CHANNEL";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
const UPDATE_BLOG_POST = "UPDATE_BLOG_POST";
const DELETE_BLOG_POST = "DELETE_BLOG_POST";
const SET_BLOG_POST_LIKE = "SET_BLOG_POST_LIKE";
const DELETE_BLOG_POST_LIKE = "DELETE_BLOG_POST_LIKE";
const GET_BLOG_POST_BY_USER = "GET_BLOG_POST_BY_USER";
const SET_BLOG_POST_BY_USER = "SET_BLOG_POST_BY_USER";
const GET_IMAGES_CARG = "GET_IMAGES_CARG";
const SEARCH_FOR_LINK_BUILDER = 'SEARCH_FOR_LINK_BUILDER';
const SAVE_BLOG_POST = 'SAVE_BLOG_POST';

export const constants = {
  CREATE_BLOG_POST,
  SEARCH_BLOG_POSTS,
  SET_BLOG_POSTS,
  SET_CURRENT_PAGE,
  GET_BLOGS_POSTS_BY_CHANNEL,
  SET_BLOGS_POSTS_BY_CHANNEL,
  UPDATE_BLOG_POST,
  DELETE_BLOG_POST,
  SET_BLOG_POST_LIKE,
  GET_BLOG_POST_BY_USER,
  DELETE_BLOG_POST_LIKE,
  SET_BLOG_POST_BY_USER,
  GET_IMAGES_CARG,
  SEARCH_FOR_LINK_BUILDER,
  SAVE_BLOG_POST,
};
// ------------------------------------
// Actions
// ------------------------------------

export const getImagesCarg = createAction(
  GET_IMAGES_CARG,
  (data,callback) => ({
    data,
    callback
  })
)

export const createBlogPost = createAction(
  CREATE_BLOG_POST,
  (blogpost, callback) => ({
    blogpost,
    callback,
  })
);

export const saveBlogPost = createAction(
  SAVE_BLOG_POST,
  (blogpost, callback) => ({
    blogpost,
    callback,
  })
)

export const searchBlogPosts = createAction(
  SEARCH_BLOG_POSTS,
  (filters, page) => ({ filters, page })
);

export const searchBlogPostLinkBuilder = createAction(
  SEARCH_FOR_LINK_BUILDER,
  (text,callback) => ({ text,callback })
)

export const setBlogPosts = createAction(
  SET_BLOG_POSTS,
  (blogsPosts, count, countTaxonomys) => ({
    blogsPosts,
    count,
    countTaxonomys
  })
);

export const setCurrentPage = createAction(SET_CURRENT_PAGE, (currentPage) => ({
  currentPage,
}));

export const getBlogsPostsByChannel = createAction(
  GET_BLOGS_POSTS_BY_CHANNEL,
  (ChannelId) => ({ ChannelId })
);

export const getBlogsPostsByUser = createAction(
  GET_BLOG_POST_BY_USER,
  (callback) => ({ callback })
);

export const setBlogsPostsByUser = createAction(
  SET_BLOG_POST_BY_USER,
  (data) => ({data}) 
)

export const setBlogsPostsByChannel = createAction(
  SET_BLOGS_POSTS_BY_CHANNEL,
  (blogsPostByChannel) => ({ blogsPostByChannel })
);

export const updateBlogPost = createAction(
  UPDATE_BLOG_POST,
  (blogPostId, data, callback) => ({ blogPostId, data, callback })
);

export const deleteBlogPost = createAction(
  DELETE_BLOG_POST,
  (blogPostId, callback) => ({
    blogPostId,
    callback,
  })
);

export const setBlogPostLike = createAction(
  SET_BLOG_POST_LIKE,
  (data, callback) => ({
    data,
    callback,
  })
);
export const deleteBlogPostLike = createAction(
  DELETE_BLOG_POST_LIKE,
  (id, callback) => ({ id, callback })
);

export const actions = {
  createBlogPost,
  searchBlogPosts,
  getImagesCarg,
  searchBlogPostLinkBuilder,
  setBlogPosts,
  setCurrentPage,
  getBlogsPostsByChannel,
  setBlogsPostsByChannel,
  getBlogsPostsByUser,
  setBlogsPostsByUser,
  updateBlogPost,
  deleteBlogPost,
  setBlogPostLike,
  deleteBlogPostLike,
  saveBlogPost
};
